import React from "react";
import Chips from "../Chips";
import Tooltip from "../Tooltip";

import { getWinClassName, betGroupProp } from "@/modules/commonMobile";
import { IKeyNumberDict } from "@/types/GlobalTypes";
import { isIPhone } from "@/modules/iOSDetection";

interface IProps {
    // Use commonBetProps & spread operator
    pcode: string;
    chipBase: number[];
    langStr: string;

    mobile?: boolean;
    bets: IKeyNumberDict;
    insertBet: (e: any) => void;

    betOutOfBounds?: {[betKey: string]: boolean};

    // Always custom
    // CSS Classes
    classes: string;

    // Bet type & group, will be used to submit bets to the server
    bet: string;
    group: string;

    // Win blinking, retrieved from loadNewValue & evaluated in each Table component class
    winStatement: boolean;

    // The label of the Table cell
    betLabel: string | JSX.Element;
    // The prize label above betLabel
    betType?: string;

    // Enable chip tooltip or not (usually is set to true on portrait mode)
    noTooltip?: boolean;

    hasHover?: boolean;

    // Only used in games that include mouse hover feature
    hoverStatement?: boolean;

    // Only apply these props if hoverStatement is true, see Roulette (p7) for example
    mouseLeave?: (e: any) => void;
    mouseOver?: (e: any) => void;
}

//How to use:
//1. Copy this before return statement:
// const commonBetProps = {
//     pcode: this.props.pcode,
//     chipBase: this.props.chipBase,
//     mobile: this.props.mobile,
//     bets: this.props.bets,
//     insertBet: this.props.insertBet,
//     langStr: this.props.langdata.language_code
// };

//2. Copy this template to substitute bets:
// <SlBet {...commonBetProps}
//     classes=""
//     
//     bet=""
//     group=""
//     
//     winStatement={}
//     
//     betLabel={}
//     betType={}
//     
//     noTooltip={}
// />

//- Example (filled for mobile portrait):
// <SlBet {...commonBetProps}
//     classes="sl-bet col-xs-6 sl-baccarat-bet-blue"
//     
//     bet="playerpair"
//     group="playerpair"
//     
//     winStatement={pairs.player}
//     
//     betLabel={this.props.langdata["txt_player_pair"]}
//     betType={"11:1"}
//     
//     noTooltip={true}
// />

// For newer games, use this Pug template:
// SlBet(
//     ...commonBetProps
//     classes= ""
// 
//     bet= ""
//     group= ""
// 
//     winStatement= false //- change this later
// 
//     betLabel= ""
//     betType= ""
// )

// Example (filled)
// SlBet(
//     ...commonBetProps
//     classes="sl-bet red"
// 
//     bet= item
//     group= item
// 
//     winStatement= false
// 
//     betLabel= item
//     betType= "1:1"
// )

//Note: New games should use this component instead of creating new ones manually
export default class SlBet extends React.Component<IProps> {
    render() {
        const hoverClass = this.props.hoverStatement ? " sl-bet-hover" : "";
        const winClass = getWinClassName(this.props.winStatement); //(win < 12 && win > 0)

        const {bet, group, betLabel} = this.props;

        const betKey = `${bet}+${group}`;

        const commonHoverHiddenProps = {
			onClick: this.props.insertBet,
			onMouseLeave: !isIPhone() ? this.props.mouseLeave : undefined,
			onMouseOver: !isIPhone() ? this.props.mouseOver : undefined
        };

        return (
            <div className={
                    this.props.classes + hoverClass + winClass +
                    (!this.props.betType ? " notype" : "")
                }
                {...{
                    bet: bet,
                    group: group,
                    pcode: this.props.pcode
                }}

                {...this.props.hasHover ? null : {
                    onClick: this.props.insertBet
                }}
                >

                {
                    typeof(betLabel) === typeof(Element) ?
                    betLabel : <div className="bet-label">{betLabel}</div>
                }

                {
                    this.props.betType ?
                    <div className="bet-type">
                        {this.props.betType}
                    </div> : null
                }
                
                <Chips
                    mobile={this.props.mobile}
                    betOutOfBounds={this.props.betOutOfBounds}
                    chipBase={this.props.chipBase}
                    bets={this.props.bets}
                    betKey={betKey} />

                {
                    this.props.noTooltip ? null :
                    <Tooltip bet={this.props.bets[betKey]} langStr={this.props.langStr} />
                }

                {
                    this.props.hasHover ?
                    <div className="sl-hover-hidden"
                        {...betGroupProp(this, this.props.bet, this.props.group)}
                        {...commonHoverHiddenProps} /> : null
                }
            </div>

        );
    }
}